(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('emptyText', emptyText);

    function emptyText(CommonHelper) {
        return function (value, defaultText) {
            if (!defaultText) {
                defaultText = '-';
            }

            if (CommonHelper.isEmpty(value)) {
                return defaultText;
            }
            return value;
        };
    }
})();